export const SAVE_SUCCESS = 'SAVE_SUCCESS';
export const SAVE_PENDIND = 'SAVE_PENDIND';
export const SAVE_FAIL = 'SAVE_FAIL';
export const SAVE_HOLDER_DATA = "SAVE_HOLDER_DATA";
export const SAVE_DOC_ID = "SAVE_DOC_ID"

export const CAT_TYPE = "CAT_TYPE";